import React, { useState } from "react";
import { FaComments, FaWhatsapp } from "react-icons/fa";
import ChatModal from "./ChatModal";

const FloatingChat = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Floating buttons */}
      <div className="fixed bottom-6 right-4 z-50 flex flex-col gap-4 items-end">
        {/* Chatbot toggle */}
        <button
          onClick={() => setOpen(true)}
          className="bg-blue-600 hover:bg-blue-700 text-white p-4 rounded-full shadow-lg transition transform hover:scale-105"
          title="Chat with AI Assistant"
        >
          <FaComments size={20} />
        </button>

        {/* WhatsApp */}
        <a
          href="https://wa.me/61403883559"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition transform hover:scale-105"
          title="WhatsApp Us"
        >
          <FaWhatsapp size={20} />
        </a>
      </div>

      {/* Modal */}
      {open && <ChatModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default FloatingChat;
